import React from 'react';
import styles from './MajorBox.module.scss';
import timeIcon from '../../../assets/icons/programs/major/timeStamp.svg';
import calendarIcon from '../../../assets/icons/programs/major/calendar.svg';
import studentIcon from '../../../assets/icons/programs/major/student.svg';
import languageIcon from '../../../assets/icons/programs/major/languages.svg';
import moreInfo from '../../../assets/icons/programs/major/moreInfo.svg';
import Separator from '../../Atoms/separator/Separator';
import editSvg from '../../../assets/icons/formActions/edit.svg';
import deleteSvg from '../../../assets/icons/formActions/delete.svg';
import InfoButton from '../../Atoms/InfoButton/InfoButton';
import { useNavigate } from 'react-router-dom';
import he from 'he';
const creditHoursText = (hours) => {
  const n = Number(hours);
  if (!Number.isFinite(n)) return '';

  const label = n === 1 ? 'ساعة معتمدة' : 'ساعات معتمدة';
  return `${n} ${label}`;
};
function MajorBox({ program, setDeletState }) {
  const navigate = useNavigate();
  const menuItems = [
    {
      label: 'تعديل',
      icon: editSvg,
      onClick: () =>
        navigate(`/home/programs/edit/${program.degreeId}`, {
          state: { mode: 'edit' },
        }),
    },
    {
      label: 'حذف',
      icon: deleteSvg,
      onClick: () =>
        setDeletState((prev) => ({
          ...prev,
          isDelete: true,
          selectedItem: program.degreeId,
        })),
    },
  ];

  let color = '';
  switch (program.degreeType) {
    case 0:
      color = 'green';
      break;
    case 1:
      color = 'blue';
      break;
    case 2:
      color = 'red';
      break;
    default:
      color = 'green';
  }

  const programLanguage = (language) => {
    switch (language) {
      case 1:
        return 'الإنجليزية';
      case 2:
        return 'لعربية والإنجليزية';
      case 3:
        return 'العربية';
    }
  };
  return (
    <div className={`${styles['major-box']} ${styles[`border-${color}`]}`}>
      <div className={`${styles['color-head']} ${styles[color]}`}></div>
      <div className={styles['major-descriptions']}>
        <div>
          <InfoButton
            icon={moreInfo}
            className={styles['more-info']}
            data={menuItems}
            left
          />
        </div>
        <p style={{ textTransform: 'uppercase' }} className={styles['title']}>
          {program.degreeNameAr}
        </p>

        <div
          className={styles['description']}
          dangerouslySetInnerHTML={{
            __html: he.decode(program.aboutProgramAr ?? ''),
          }}
        />
        <div className={styles['grid-container']}>
          <Separator direction='horizontal' style={{ height: '50px' }} />
          <div className={styles['grid']}>
            <div className={styles['grid-items']} style={{ width: '70%' }}>
              <div className={styles['textWithSvg']}>
                <img src={studentIcon} alt='Pre-requisites' />
                <span>{program.entryLevelAr}</span>
              </div>
              <div className={styles['textWithSvg']}>
                <img src={calendarIcon} alt='Years' />
                <span style={{ direction: 'rtl' }}>{program.durationAr}</span>
              </div>
            </div>
            <div className={styles['grid-items']} style={{ width: '40%' }}>
              <div className={styles['textWithSvg']}>
                <img src={languageIcon} alt='Language' />
                <span>{programLanguage(program.languages)}</span>
              </div>
              <div className={styles['textWithSvg']}>
                <img src={timeIcon} alt='Count' />
                <span>{creditHoursText(program?.creditHours)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {isEditModalOpen && <EditModal onClose={handleCloseModal} />} */}
    </div>
  );
}

export default MajorBox;
